import Swiper, { Navigation, Pagination } from 'swiper/core'; // eslint-disable-line

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

const sliderComponents = document.querySelectorAll('.o-slider');

sliderComponents.forEach(($sliderComponent) => {
  const $slider = $sliderComponent.querySelector('.swiper-container');
  const $arrowPrev = $sliderComponent.querySelector('.swiper-button-prev');
  const $arrowNext = $sliderComponent.querySelector('.swiper-button-next');
  // eslint-disable-next-line
  const slider = new Swiper($slider, {
    autoHeight: false,
    loop: false,
    slidesPerView: 1,
    spaceBetween: 8,
    watchOverflow: true,
    navigation: {
      prevEl: $arrowPrev,
      nextEl: $arrowNext,
    },
    pagination: {
      el: '.o-slider__pagination',
      clickable: true,
      renderBullet: (index, className) => `<span class="o-slider__pagination-bullet ${className}"></span>`,
      bulletClass: 'o-slider__pagination-bullet',
      bulletActiveClass: 'o-slider__pagination-bullet--active',
      clickableClass: 'o-slider__pagination-bullet--clickable',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 8,
      },
      1260: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 16,
      },
    },
  });
});
